import type { WaitActionsProps } from '../../../../AdditionalSalesV2/saleProgress'
import useVoltalisStatusRefresh from './useVoltalisStatusRefresh'
import { TertiaryButton } from '../../../../AdditionalSalesV2/styled-components'

const VoltalisStatusRefresh = ({ saleType, t }: WaitActionsProps) => {
  const { refresh } = useVoltalisStatusRefresh(saleType, t)

  return (
    <TertiaryButton type='button' onClick={refresh}>
      {t('additionalSales:leadVoltalisBizdev.reload_status')}
    </TertiaryButton>
  )
}

export default VoltalisStatusRefresh
